<template>
    <div>
    <div class="uk-text-center uk-margin-top" v-if="(isAdmin || isManager) && (currentRouteName === 'management')">
      <router-link to="/management/paycode/create" class="uk-button uk-button-primary">Create new PayCode</router-link>
    </div>
    <table class="uk-table uk-table-small uk-table-divider">
            <thead>
                <tr>
                    <th class="uk-table-shrink">N</th>
                    <th>Title</th>
                    <th>PayCode</th>
                    <th>created At</th>
                    <th>Users</th>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(paycode, index) in paycodes" :key="paycode.id">
                    <td>{{index + 1}}</td>
                    <td>{{paycode.title}}</td>
                    <td>{{paycode.code}}</td>
                    <td>{{paycode.createdAt | formatDate }}</td>
                    <td>
                      <ul v-for="(user, index) in paycode.users" :key="user.id">
                        <li>{{index + 1}}. {{user.firstName}} {{user.lastName}} ({{user.email}})</li>
                      </ul>
                    </td>
                    <td>
                      <ul class="uk-iconnav s">
                          <li v-if="paycode.use"><a href="#" uk-icon="icon: lock" uk-tooltip="unlock paycode" @click.prevent="paycode.use = !paycode.use; updatePayCode(paycode)"></a></li>
                          <li v-if="!paycode.use"><a href="#" uk-icon="icon: unlock" uk-tooltip="lock paycode" @click.prevent="paycode.use = !paycode.use; updatePayCode(paycode)"></a></li>
                      </ul>
                    </td>
                </tr>
            </tbody>
    </table>
    </div>
</template>

<script>
import PayCodeService from '@/services/paycode.service';
export default {
    name: 'PayCode',
    data() {
        return {
            checkPayCode: '',
            paycodes: []
        }
    },
    mounted() {
        PayCodeService.getPayCodes().then(
            res => {
                this.paycodes = res.data;
            },
            error => {
                console.log(error.message);
            }
        )
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
         },
        isAdmin() {
            if (this.currentUser && this.currentUser.roles) {
                return this.currentUser.roles.includes('admin');
            }
            return false;
        },
        isManager() {
            if (this.currentUser && this.currentUser.roles) {
                return this.currentUser.roles.includes('manager');
            }
            return false;
        },
        currentRouteName() {
            return this.$route.name;
        }
    },
    methods: {
        updatePayCode(data){
            PayCodeService.updatePayCode(data).then(
                res => {
                    this.paycodes.forEach((paycode) => {
                        if(paycode._id === res.data._id)
                            paycode = res.data;
                    });
                    this.checkPayCode = '';
                },
                error => {
                    console.log(error.message);
                }
            )
        }
    },
}
</script>

<style>
.uk-iconnav.s {
  position: relative;
  border: none;
}
</style>